import { render, staticRenderFns } from "./DYGoodDetail.vue?vue&type=template&id=24647c48&scoped=true"
import script from "./DYGoodDetail.vue?vue&type=script&lang=js"
export * from "./DYGoodDetail.vue?vue&type=script&lang=js"
import style0 from "./DYGoodDetail.vue?vue&type=style&index=0&id=24647c48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24647c48",
  null
  
)

export default component.exports